// TODO: Move this component to common-components if needed
import { memo, useCallback } from 'react'
import { useKeyPressWithConfigs } from 'hooks'
import { RangeSlider } from 'common-components'
import ZoomIn from 'assets/svgr-icons/Zoom_In.svg'
import ZoomOut from 'assets/svgr-icons/Zoom_Out.svg'
import { useResponsive } from 'hooks/useResponsive'
import { MOBILE_SIZE_BREAKPOINT } from 'consts'

import * as Styled from './styled'

interface IProps {
  zoomValue: number
  minValue: number
  maxValue: number
  step: number
  onChange: (value: number) => void
}

const ZoomInOut: React.FC<IProps> = ({
  zoomValue,
  minValue,
  maxValue,
  onChange,
  step = 1
}) => {
  const isMobile = useResponsive(MOBILE_SIZE_BREAKPOINT)

  const zoomInHandler = useCallback(() => {
    if (zoomValue < maxValue) {
      onChange(zoomValue + step)
    }
  }, [zoomValue, maxValue, onChange, step])

  const zoomOutHandler = useCallback(() => {
    if (zoomValue > minValue) {
      onChange(zoomValue - step)
    }
  }, [zoomValue, minValue, onChange, step])

  const zoomHandler = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange(+e.target.value)
    },
    [onChange]
  )

  useKeyPressWithConfigs('plus', zoomInHandler, {
    configs: { metaKey: true },
    targetAreaSelector: '.timeline-container'
  })
  useKeyPressWithConfigs('minus', zoomOutHandler, {
    configs: { metaKey: true },
    targetAreaSelector: '.timeline-container'
  })

  return (
    <Styled.ZoomInOutWrapper>
      <Styled.IconWrapper onClick={zoomOutHandler}>
        <ZoomOut />
      </Styled.IconWrapper>

      {isMobile ? null : (
        <RangeSlider
          minValue={minValue}
          maxValue={maxValue}
          value={zoomValue}
          onChange={zoomHandler}
          isFullWidth
        />
      )}

      <Styled.IconWrapper onClick={zoomInHandler}>
        <ZoomIn />
      </Styled.IconWrapper>
    </Styled.ZoomInOutWrapper>
  )
}

export default memo(ZoomInOut)
